export class LookupDetails {
    assessmentAssociated: [];
    mobilityLevel: [];
    positions: [];
    regions: [];
    types: [];
    mobileUiVersion: string;
    responseCode: number;
    responseMessage: string;
}